module.exports = __webpack_public_path__ + "files/662f7659fd52dfc1ff799855bc9bd0b3.svg";